module.exports = __webpack_public_path__ + "static/group-image2-fa087ff74e9c039c31e146a3f7e8ee36.jpg";